import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { UiButtonDirective } from '@df/ui/button/button.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { UiComponent } from '@df/ui/ui.component';
import { ScrollToDirective } from '@df/ui/util/scroll/scroll-to.directive';
import { ProductLayoutComponent } from '../../product-layout.component';
import { ProductLayoutAddToBasketComponent } from '../product-layout-add-to-basket.component';

@Component({
    selector: 'product-layout-add-to-basket-panel',
    templateUrl: './product-layout-add-to-basket-panel.component.html',
    styleUrl: './product-layout-add-to-basket-panel.component.scss',
    host: {
        '[class.is-visible]': 'visible()'
    },
    imports: [PriceComponent, ProductLayoutAddToBasketComponent, ScrollToDirective, UiButtonDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutAddToBasketPanelComponent extends UiComponent {
    readonly productViewLayout = input.required<ProductLayoutComponent>();
    readonly visible = input<boolean>(true);

    readonly productConfiguration = computed(() => this.productViewLayout().productConfiguration);

    private readonly scrollToService = inject(ScrollToService);

    get hasColorOption(): boolean {
        const options = this.productConfiguration().options$?.value?.find(option => option.attribute.id === 'color')?.values ?? [];

        return options.length > 1;
    }

    protected handlePaletteClick(): void {
        if (this.client.isL || this.client.isX) {
            this.scrollToService.scrollTo('#product-details');
        } else {
            this.productViewLayout().openProductLayoutConfigurableOptionsModal(true);
        }
    }
}
